<template>
    <svg
        id="Fullscreen_out"
        data-name="Fullscreen out"
        xmlns="http://www.w3.org/2000/svg"
        width="17.605"
        height="17.605"
        viewBox="0 0 17.605 17.605"
    >
        <path
            id="Pfad_454"
            data-name="Pfad 454"
            d="M602.711,371.6a.911.911,0,0,1-.911-.911v-5.524a.911.911,0,1,1,1.821,0v5.524A.911.911,0,0,1,602.711,371.6Z"
            transform="translate(-596.276 -364.25)"
            :class="fillClass + ' transition-fill'"
        />
        <path
            id="Pfad_455"
            data-name="Pfad 455"
            d="M603.685,370.621h-5.524a.911.911,0,1,1,0-1.821h5.524a.911.911,0,0,1,0,1.821Z"
            transform="translate(-597.25 -363.276)"
            :class="fillClass + ' transition-fill'"
        />
        <path
            id="Pfad_456"
            data-name="Pfad 456"
            d="M606.611,371.6a.911.911,0,0,1-.911-.911v-5.524a.911.911,0,1,1,1.821,0v5.524A.911.911,0,0,1,606.611,371.6Z"
            transform="translate(-595.441 -364.25)"
            :class="fillClass + ' transition-fill'"
        />
        <path
            id="Pfad_457"
            data-name="Pfad 457"
            d="M612.135,370.621h-5.524a.911.911,0,0,1,0-1.821h5.524a.911.911,0,1,1,0,1.821Z"
            transform="translate(-595.441 -363.276)"
            :class="fillClass + ' transition-fill'"
        />
        <path
            id="Pfad_458"
            data-name="Pfad 458"
            d="M602.711,380.046a.911.911,0,0,1-.911-.911v-5.524a.911.911,0,1,1,1.821,0v5.524A.911.911,0,0,1,602.711,380.046Z"
            transform="translate(-596.276 -362.441)"
            :class="fillClass + ' transition-fill'"
        />
        <path
            id="Pfad_459"
            data-name="Pfad 459"
            d="M603.685,374.521h-5.524a.911.911,0,1,1,0-1.821h5.524a.911.911,0,0,1,0,1.821Z"
            transform="translate(-597.25 -362.441)"
            :class="fillClass + ' transition-fill'"
        />
        <path
            id="Pfad_460"
            data-name="Pfad 460"
            d="M606.611,380.046a.911.911,0,0,1-.911-.911v-5.524a.911.911,0,1,1,1.821,0v5.524A.911.911,0,0,1,606.611,380.046Z"
            transform="translate(-595.441 -362.441)"
            :class="fillClass + ' transition-fill'"
        />
        <path
            id="Pfad_461"
            data-name="Pfad 461"
            d="M612.135,374.521h-5.524a.911.911,0,0,1,0-1.821h5.524a.911.911,0,1,1,0,1.821Z"
            transform="translate(-595.441 -362.441)"
            :class="fillClass + ' transition-fill'"
        />
    </svg>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "ZoomOutIcon",
    props: {
        fillClass: {
            type: String,
            required: true,
        },
    },
});
</script>
